module.exports = __webpack_public_path__ + "8f9d20e254b30f83025092a0e5649b87.svg";